import './OrganizationList.css'
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import logo from '../../assets/una-logo.png'
import { useFetch } from '../../contexts/FetchProvider';
import { FaInfoCircle } from "react-icons/fa";
import { Tooltip } from 'flowbite-react';

const OrganizationList = () => {
  const { saveOrganization, saveModulesAccess } = useFetch();
  const roles = JSON.parse(localStorage.getItem('roles'));
  const [organization, setOrganization] = useState();

  const { register, handleSubmit } = useForm();

  const navigate = useNavigate()

  const onSubmit = async (data) => {
    saveOrganization(organization.id);
    saveModulesAccess(organization.modules);
    localStorage.setItem('oid', JSON.stringify(organization.id))
    navigate(`/organizations/credentials`, { replace: true })
  }

  const roleColorCodeInfo = () => {
    return (
      <div>
        <div className='flex'>
          <div className='w-4 h-4 bg-orange-500 mr-1'></div>
          <div>{` Indicates pending tasks`}</div>
        </div>
      </div>
    )
  }

  const taskInfo = (item) => {
    return (
      <div className='overflow-x-auto'>
        <table className='min-w-full table-auto border-collapse border border-gray-300'>
          <thead>
            <tr>
              <th className='border border-gray-300 px-2 py-1 text-left text-sm font-semibold'>Task Detail</th>
              <th className='border border-gray-300 px-2 py-1 text-left text-sm font-semibold'>Pending Count</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={`border border-gray-300 px-2 py-1 text-sm`}>Test</td>
              <td className={`border border-gray-300 px-2 py-1 text-sm`}>{item?.tests}</td>
            </tr>
            <tr>
              <td className={`border border-gray-300 px-2 py-1 text-sm`}>Checklist</td>
              <td className={`border border-gray-300 px-2 py-1 text-sm`}>{item?.checklists}</td>
            </tr>
            <tr>
              <td className={`border border-gray-300 px-2 py-1 text-sm`}>Mandatory</td>
              <td className={`border border-gray-300 px-2 py-1 text-sm`}>{item?.courses}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }


  return (
    <div className="unac-roles-container bg-gray">
      <div className="unac-roles-header">
        <img className='p-2' src={logo} alt="logo" />
      </div>
      <div className="unac-roles-body">
        <Container>
          <Row className="justify-content-md-center">
            <Col sm md={6}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="unac-roles mt-3">
                  <div className="unac-role-header px-2">
                    <div className='cursor-pointer'>
                      <Tooltip className="bg-black text-sm font-medium rounded"
                        content={roleColorCodeInfo()}
                      >
                        <FaInfoCircle className='scale-100' />
                      </Tooltip>
                    </div>
                    <h3>Select Organization</h3>
                    <button className="unac-btn-secondary m-2 auto-width-btn" disabled={!organization?.id} type='submit'>Done</button>
                  </div>
                  <div className='unac-roles-list-view'>
                    {
                      roles.map((role, i) => {
                        const { organization: { pending_content } } = role
                        const colorCoding = () => {
                          return Object.values(pending_content).every((item) => item === 0)
                        }
                        return (
                          <label className='unac-role-single pointer' key={i} >
                            <div className='unac-left-section'>
                              <input
                                className='unac-role-radio'
                                name="roles"
                                type='radio'
                                value={role.organization}
                                {...register("organization")}
                                onChange={() => setOrganization(role.organization)}

                              />

                              <div className='unac-left-section-details'>
                                <div className='flex items-center'>
                                  <div className={`unac-role-company ${colorCoding() ? "text-black" : "text-orange-500"}`}>{role.organization.title}</div>
                                  {!colorCoding() && <div className='ml-2 -mt-1'>
                                    <Tooltip className="bg-black text-sm font-medium rounded"
                                      content={taskInfo(pending_content)}
                                      placement='top'
                                    >
                                      <FaInfoCircle className='scale-100' />
                                    </Tooltip>
                                  </div>}
                                </div>
                                <div className='unac-role-company-role unac-txt-cap unac-fs-12'>{role.name === "nurse" ? "Healthcare professional" : role.name}</div>
                              </div>
                            </div>

                            <div className='unac-right-section right-0 flex'>
                              <div className='unac-role-company'>
                                <img className='unac-role-company-logo img-fluid' src={role.organization.logo_url || logo} alt={role.organization.name} />
                              </div>
                            </div>
                          </label>
                        )
                      }

                      )
                    }
                  </div>
                </div>
              </form>
            </Col>
          </Row>
        </Container >
      </div>
    </div>
  )
}

export default OrganizationList